@if(auftrag(); as auftrag) {
  <soft-page>
    <soft-page-header>
      <soft-picking-order [pickingOrder]="auftrag" [small]="!!config?.showLessInfoInArticleView"></soft-picking-order>
    </soft-page-header>
    @if (bewe(); as bewe) { @if(strategy(); as strategy) {
      <div class="pb-24">
        <div class="soft-overline mt-4">
          {{'#KOMMISSIONIERUNG.PAGES.ARTIKEL_MENGE.ARTIKEL' | translate}}
        </div>
        <div class="soft-card">
          <soft-store-item [bewe]="bewe"></soft-store-item>
        </div>

        @if((strategy?.lagerplatzAuswahl || strategy?.loadLagerplatzVorschlag) &&
          !bewe.offenePaletten?.length) {
          <div class="soft-overline mt-4">
            {{'#KOMMISSIONIERUNG.PAGES.ARTIKEL_MENGE.LAGERPLATZ' | translate}}
          </div>
          <soft-lagerplatz-suche
            [lagerplatz]="$safeNavigationMigration((lagerplatz$ | async)?.lagerplatz)"
            (lagerplatzInhaltChange)="onLagerplatzChange($event)"
            (lagerplatzChange)="onLpChange($event)"
            [changeable]="strategy?.lagerplatzAuswahl ?? false"
            [idbewekomm]="strategy?.loadLagerplatzVorschlag ? bewe.id : null"
            [storageId]="$safeNavigationMigration(auftrag?.lager?.id)"
            [disableScan]="true"
          ></soft-lagerplatz-suche>
          } @if((bewe.offenePaletten?.length || 0) > 0 ){
          <div class="soft-overline mt-4">
            {{'#KOMMISSIONIERUNG.PAGES.ARTIKEL_MENGE.PALETTE' | translate}}
          </div>
          <div class="flex flex-col gap-2">
            @for (pallet of bewe.offenePaletten; track pallet.id; let index = $index) {
              <div
                class="soft-card flex flex-row items-center gap-2 cursor-pointer hover:bg-hover"
                [ngClass]="{'!bg-selected': selectedPalette()?.id === pallet.id}"
                (click)="selectPalette(pallet)"
                >
                <soft-checkbox
                  [checked]="selectedPalette()?.id === pallet.id"
                  [readonly]="true"
                ></soft-checkbox>
                <soft-picking-pallet
                  class="w-full"
                  [number]="index + 1"
                  [pallet]="pallet"
                ></soft-picking-pallet>
              </div>
            }
          </div>
        } @else {
          <div class="soft-overline mt-4">
            {{'#KOMMISSIONIERUNG.PAGES.ARTIKEL_MENGE.MENGE' | translate}}
          </div>
        <div class="flex flex-row w-full gap-2 items-center mt-1">
          <soft-mengen-eingabe
            class="w-full"
            [preventKeyboardEventEmission]="true"
            [disabled]="(disabled$ | async) ?? false"
            [value]="(menge$ | async) ?? 0"
            [einheit]="bewe.artikelMengeOffen.einheit.arteh"
            [maxValue]="(maxMenge$ | async) ?? 0"
            [float]="true"
            (valueChange)="onMengeChange(auftrag.id, bewe.id, $event)"
          ></soft-mengen-eingabe>
          <!--  Mengen Eingabe Öffnen   -->
          @if (bewe?.einheitenEingabeErlaubt) {
            <button
              class="soft-button primary flex items-center h-full justify-center text-white min-w-[3.5rem] rounded-sm w-16"
              style="height: stretch;"
              (click)="openMengeDialog(auftrag.id, bewe)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V13.5zm0 2.25h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V18zm2.498-6.75h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V13.5zm0 2.25h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V18zm2.504-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zm0 2.25h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V18zm2.498-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zM8.25 6h7.5v2.25h-7.5V6zM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 002.25 2.25h10.5a2.25 2.25 0 002.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0012 2.25z"
                />
              </svg>
            </button>
          }
        </div>

        }
      </div>
      <button
        class="fixed left-0 right-0 bottom-0 soft-button primary w-full h-20 mt-16"
        [disabled]="isValid()"
        (click)="onSubmit()"
        >
        {{'#KOMMISSIONIERUNG.PAGES.ARTIKEL_MENGE.SUBMIT' | translate}}
      </button>
      } }
    </soft-page>
  }

  @if (loading$ | async) {
    <soft-blocking-loading-spinner
      class="top-0 right-0"
    ></soft-blocking-loading-spinner>
  }


<ng-template #inventoryHeaderTemplate>
  <div class="bg-warning-500/10 border-warning border w-full p-2 rounded-md">
    <h1 class="text-xl font-semibold">Lagerstand des Artikels ist 0!</h1>
    <span class="text-sm text-light">Bitte bestätigen Sie den Lagerstand oder korrigieren Sie diesen!</span>
  </div>
</ng-template>
